import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import { Polyline } from 'react-leaflet';
import { getTrack, sortTrack } from './track.utils';
import { IHistoryTelemetry } from '@store/Map.store';

interface IProps {
    coords: IHistoryTelemetry[];
}

const Component: React.FC<IProps> = ({ coords }: IProps) => {
    const polylineRef = useRef<any>(null);

    useEffect(() => {
        const polyline = polylineRef.current;
        if (polyline && polyline._map) {
            const map = polyline._map;
            const coords = polyline._latlngs;
            const dotsNum = coords.length;
            if (dotsNum) {
                const segments = new Array(dotsNum - 1)
                    .fill(0)
                    .map((v, i) => [coords[i], coords[i + 1]])
                    .map((v, i) => {
                        const line = L.polyline(v, { stroke: false }).addTo(
                            map,
                        );
                        const isArrow =
                            i + 1 === 1 ||
                            (i + 1) % 10 === 0 ||
                            i + 1 === dotsNum - 1;
                        if (isArrow)
                            return L.polylineDecorator(line, {
                                patterns: [
                                    {
                                        offset: '50%',
                                        repeat: 0,
                                        symbol: L.Symbol.arrowHead({
                                            pixelSize: 10,
                                            polygon: false,
                                            pathOptions: {
                                                stroke: true,
                                                fillOpacity: 1,
                                            },
                                        }),
                                    },
                                ],
                            }).addTo(map);
                    })
                    .filter((v) => v);
                return () => {
                    segments.forEach((item) => {
                        if (item && item.removeFrom) {
                            item.removeFrom(map);
                        }
                    });
                };
            }
        }
    }, [coords]);

    const track = coords ? getTrack(coords.sort(sortTrack)) : [];

    return (
        <>
            <Polyline positions={track} ref={polylineRef} />
        </>
    );
};

const TrackComponent = React.memo(Component);

export default TrackComponent;
